// extracted by mini-css-extract-plugin
export var dropdown = "_qw-0";
export var imageWrapper = "_qw-3";
export var itemNameContainer = "_qw-1";
export var productImage = "_qw-2";
export var spinnerWrapper = "_qw-4";